module.exports = __webpack_public_path__ + "static/img/last_msg.09ae955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/last_msg.png
// module id = 71f+
// module chunks = 1 3